import { FaBusinessTime, FaBan, FaClock, FaSmileBeam } from "react-icons/fa";
import "../styles/exclusions.css";

function Exclusions() {
  const exclusions = [
    {
      text: "még nincs működő vállalkozásod",
      icon: <FaBusinessTime size={30} />,
    },
    {
      text: "a terméked vagy szolgáltatásod nem piacképes",
      icon: <FaBan size={30} />,
    },
    {
      text: "folyamatosan halogatsz, és nem vagy kész a fejlődésre",
      icon: <FaClock size={30} />,
    },
    {
      text: "nem szeretnél több vásárlót, mert elégedett vagy a jelenlegi állapottal",
      icon: <FaSmileBeam size={30} />,
    },
  ];

  return (
    <section id="exclusions" className="exclusions-section">
      <div className="container">
        <div className="px-3 px-md-0">
          <h2 className="exclusions-title">Kinek nem tudok segíteni?</h2>
          <ul className="exclusions-list">
            {exclusions.map((item, index) => (
              <li key={index} className="exclusions-item">
                <span className="exclusions-item-icon">{item.icon}</span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="curved-divider-exclusions">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            fill="#2C2F36"
            d="M0,70 C360,100 1080,0 1440,70 L1440,100 L0,100 Z"
          />
        </svg>
      </div>
    </section>
  );
}

export default Exclusions;
